import { selectBalancingPurchaseOfferGroups } from "../balancingSelectors/selectBalancingPurchaseOfferGroups";
import { IdPurchaseOfferGroup } from "../constants/IdPurchaseOfferGroup";
import { IdLoca } from "./i18n/IdLoca";
var UtilSmsOffers = /** @class */ (function () {
    function UtilSmsOffers() {
        var _this = this;
        this.IdSmsProviderType = "sms and phone";
        this.getSMSShopProvider = function (countryCode, id) { return ({
            countryCode: countryCode,
            id: id,
            type: _this.IdSmsProviderType,
        }); };
        this.convertSmsOfferToOfferProps = function (offer) {
            var baseOffer = selectBalancingPurchaseOfferGroups().get(IdPurchaseOfferGroup.Sms);
            return {
                backgroundColor: "",
                baseGoldValue: 0,
                bonusGoldPercent: 0,
                bonusGoldValue: 0,
                imageName: "",
                locaKeyEyecatcher: baseOffer.locaKeyEyecatcher || IdLoca.empty,
                locaKeyFlavour: baseOffer.locaKeyFlavour || IdLoca.empty,
                locaKeyTitle: baseOffer.locaKeyTitle || IdLoca.empty,
                offerCharacteristicId: baseOffer.purchaseOfferCharacteristicId,
                // tslint:disable-next-line:no-empty
                onBuyClick: function () { },
                // tslint:disable-next-line:no-empty
                onCloseClick: function () { },
                primeTimeBonus: 0,
                providers: [],
                purchaseOfferNameId: baseOffer.purchaseOffer[0].nameId,
                purchasePoints: 0,
                remainingSeconds: 0,
                rewards: [],
                shopPackage: { id: offer.id },
                webBonusGold: 0,
            };
        };
        this.getSmsOffersPurchaseOfferNameId = function () {
            var baseOffer = selectBalancingPurchaseOfferGroups().get(IdPurchaseOfferGroup.Sms);
            return baseOffer.purchaseOffer[0].nameId;
        };
    }
    return UtilSmsOffers;
}());
export var utilSmsOffers = new UtilSmsOffers();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilSmsOffers.ts
// module id = 1878
// module chunks = 3